var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { IconButton as MuiIconButton } from '@material-ui/core';
import clsx from 'clsx';
import { upperFirst } from 'lodash';
import { acidForwardRef } from '../../utilities/forwardRef';
var getHoverOpacity = function (color) { return "rgba(".concat(color.replace(/r|g|b|\(|\)/g, ''), ", 0.2)"); };
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e;
    return ({
        square: {
            borderRadius: theme.shape.borderRadius,
        },
        primary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: getHoverOpacity(theme.palette.primary.main),
            },
        },
        secondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: getHoverOpacity(theme.palette.secondary.main),
            },
        },
        default: {
            color: (_a = theme.palette.default) === null || _a === void 0 ? void 0 : _a.main,
            '&:hover': {
                backgroundColor: getHoverOpacity((_b = theme.palette.default) === null || _b === void 0 ? void 0 : _b.main),
            },
        },
        success: {
            color: theme.palette.success.main,
            '&:hover': {
                backgroundColor: getHoverOpacity(theme.palette.success.main),
            },
        },
        info: {
            color: theme.palette.info.main,
            '&:hover': {
                backgroundColor: getHoverOpacity(theme.palette.info.main),
            },
        },
        warning: {
            color: theme.palette.warning.main,
            '&:hover': {
                backgroundColor: getHoverOpacity(theme.palette.warning.main),
            },
        },
        danger: {
            color: theme.palette.error.main,
            '&:hover': {
                backgroundColor: getHoverOpacity(theme.palette.error.main),
            },
        },
        none: {
            color: theme.palette.grey[500],
            '&:hover': {
                backgroundColor: getHoverOpacity(theme.palette.grey[500]),
            },
        },
        containedPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
        containedSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
            },
        },
        containedDefault: {
            backgroundColor: (_c = theme.palette.default) === null || _c === void 0 ? void 0 : _c.main,
            color: (_d = theme.palette.default) === null || _d === void 0 ? void 0 : _d.contrastText,
            '&:hover': {
                backgroundColor: (_e = theme.palette.default) === null || _e === void 0 ? void 0 : _e.dark,
            },
        },
        containedSuccess: {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.success.dark,
            },
        },
        containedInfo: {
            backgroundColor: theme.palette.info.main,
            color: theme.palette.info.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.info.dark,
            },
        },
        containedWarning: {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.warning.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.warning.dark,
            },
        },
        containedDanger: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.error.dark,
            },
        },
        containedNone: {
            backgroundColor: theme.palette.grey[500],
            color: theme.palette.common.white,
            '&:hover': {
                backgroundColor: theme.palette.grey[700],
            },
        },
    });
});
var IconButton = acidForwardRef(function (props, ref) {
    var children = props.children, className = props.className, _a = props.color, color = _a === void 0 ? 'none' : _a, _b = props.square, square = _b === void 0 ? false : _b, _c = props.variant, variant = _c === void 0 ? 'default' : _c, otherProps = __rest(props, ["children", "className", "color", "square", "variant"]);
    var classes = useStyles(props);
    return (React.createElement(MuiIconButton, __assign({ ref: ref }, otherProps, { color: "default", className: clsx(className, square ? classes.square : undefined, variant === 'contained'
            ? classes["contained".concat(upperFirst(String(color).toLowerCase()))]
            : classes[String(color).toLowerCase()]) }), children));
});
IconButton.defaultProps = {
    color: 'none',
    variant: 'default',
    square: false,
};
export default IconButton;
//# sourceMappingURL=IconButton.js.map